'use es6';

let apiClient;
export const getApiClient = () => apiClient;
export const setApiClient = _apiClient => {
  apiClient = _apiClient;
};